import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useField, useFormikContext } from "formik";

export function SelectField({
  formMargin = "normal",
  label,
  values = [],
  defaultValue,
  disabled,
  ...props
}) {
  const [field, meta, helpers] = useField(props);
  const { isSubmitting } = useFormikContext();
  const hasError = !!(meta.touched && meta.error);

  if (defaultValue !== undefined && !meta.touched && field.value !== defaultValue) {
    helpers.setValue(defaultValue);
  }

  return (
    <FormControl margin={formMargin} fullWidth>
      <InputLabel htmlFor={props.name} error={hasError} shrink>
        {label}
      </InputLabel>
      <Select
        disabled={disabled || isSubmitting}
        error={hasError}
        {...field}
        {...props}
        value={field.value || ""}
      >
        {values.map(({ id, value, label, disabled: disabledMenu }) => (
          <MenuItem key={id} value={value} disabled={disabledMenu}>
            {label}
          </MenuItem>
        ))}
      </Select>
      {hasError && <FormHelperText error={hasError}>{meta.error}</FormHelperText>}
    </FormControl>
  );
}
